module.exports = __webpack_public_path__ + "8028dd1166b77764314e7494f6818469.svg";